var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-property-icon-item',{attrs:{"label":_vm.label},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('parking-icon')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }